import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentForCustomerLeafWiseCollection } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { CustomerLeafWiseCollectionNewReportSchemaObject } from "../CustomerLeafWiseCollectionNewReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import '../Pages/tableFooter.css';
import tokenDecoder from '../../../../Common/tokenDecoder';

const screenCode = "CUSTOMERLEAFWISECOLLECTIONNEWREPORT";

export function CustomerLeafWiseCollectionNewReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [collectionTypes, setCollectionTypes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [total, setTotal] = useState({
        totalBagCount: 0,
        totalGross: 0,
        totalNet: 0,
        totalDeduction: 0,
        totalReturn: 0
    });

    const [searchDetails, setSearchDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        collectionTypeID: "0",
        regNo: "",
        fromDate: "",
        toDate: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        collectionType: "0",
        regNo: "",
        fromDate: "",
        toDate: ""
    });

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(CustomerLeafWiseCollectionNewReportSchemaObject).options({ allowUnknown: true });

    const contentRowNames = ["collectedDate", "collectionPointName", "regNo", "nameToBePrinted",
        "narration", "collectionTypeName", "numberOfUnits", "grossTotalAmount", "totalDeduction", "returnValue", "netAmount"];
    const csvHeaders = [
        { label: "Collected Date", value: "collectedDate" },
        { label: "Route Name", value: "collectionPointName" },
        { label: "Customer Reg. Number", value: "regNo" },
        { label: "Customer Name", value: "nameToBePrinted" },
        { label: "Narration", value: "narration" },
        { label: "Collection Type", value: "collectionTypeName" },
        { label: "Bag Count", value: "numberOfUnits" },
        { label: "Gross Amount Total (Kg)", value: "grossTotalAmount" },
        { label: "Deduction Total (Kg)", value: "totalDeduction" },
        { label: "Return Total (Kg)", value: "returnValue" },
        { label: "Net Amount Total (Kg)", value: "netAmount" }
    ];

    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [searchDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown(),
            getCollectionTypesForDropDown()
        )
    }, [searchDetails.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setSearchDetails({
            ...searchDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0",
            collectionTypeID: "0",
            regNo: ""
        });
        setIsTableHide(true);
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setSearchDetails({
            ...searchDetails,
            factoryID: target.value,
            routeID: "0",
            collectionTypeID: "0",
            regNo: ""
        });
        setIsTableHide(true);
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setSearchDetails({
            ...searchDetails,
            routeID: target.value,
        });
        setIsTableHide(true);
    }

    function handleCollectionTypeChange(target) {
        validateInputs(target);

        setSearchDetails({
            ...searchDetails,
            collectionTypeID: target.value,
        });
        setIsTableHide(true);
    }

    function handleRegNoChange(target) {
        validateInputs(target);

        setSearchDetails({
            ...searchDetails,
            regNo: target.value,
        });
        setIsTableHide(true);
    }


    function handleFromDateChange(target) {
        validateInputs(target);

        setSearchDetails({
            ...searchDetails,
            fromDate: target.value,
        });
        setIsTableHide(true);
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setSearchDetails({
            ...searchDetails,
            toDate: target.value,
        });
        setIsTableHide(true);
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, CustomerLeafWiseCollectionNewReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCUSTOMERLEAFWISECOLLECTIONNEWREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setSearchDetails({
            ...searchDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(searchDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(searchDetails.factoryID);
        setRoutes(data);
    }

    async function getCollectionTypesForDropDown() {
        const data = await services.getAllCollectionTypesByoperationEntityID(searchDetails.factoryID);
        setCollectionTypes(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, searchDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(searchDetails);

        const result = await services.getCustomerLeafWiseCollectionReport(searchDetails);
        result.reportData.forEach(x => {
            let res = result.returnData.find(y => y.returnCustomerID == x.customerID)
            if (res) {
                x.returnValue = res.totalAmount;
                x.netAmount = parseFloat(x.netAmount) - parseFloat(res.totalAmount);
            }
            else {
                x.returnValue = 0
            }
        });
        var totalValues = formatResultDataAndCalulateTotal(result.reportData);

        if (result.reportData.length > 0) {
            destroyDataTable();
            setIsTableHide(false);
            setReportData(result.reportData);
            createDataTable();
            generateCsvTotalRow(result.reportData, totalValues);
        }
    }

    function generateCsvTotalRow(data, totalValues) {
        var copyOfData = _.cloneDeep(data);

        var newTotalRow = {
            collectedDate: "Total",
            numberOfUnits: totalValues.totalBagCount,
            grossTotalAmount: totalValues.totalGross,
            totalDeduction: totalValues.totalDeduction,
            returnValue: totalValues.totalReturn,
            netAmount: totalValues.totalNet,
        };

        var newDetailRow = {
            collectedDate: "Date",
            collectionPointName: new Date().toLocaleString(),
            regNo: "User",
            nameToBePrinted: tokenDecoder.getUserNameFromToken()
        };

        copyOfData.push(newTotalRow);

        copyOfData.unshift({}, newDetailRow, {})

        setCsvData(copyOfData);
    }

    function formatResultDataAndCalulateTotal(data) {

        var bagCount = 0;
        var grossTotal = 0;
        var netTotal = 0;
        var deductionTotal = 0;
        var returnTotal = 0;

        data.forEach(x => {
            bagCount = parseInt(bagCount) + parseInt(x.numberOfUnits);
            grossTotal = parseFloat(grossTotal) + parseFloat(x.grossTotalAmount)
            netTotal = parseFloat(netTotal) + parseFloat(x.netAmount)
            deductionTotal = parseFloat(deductionTotal) + parseFloat(x.totalDeduction)
            returnTotal = parseFloat(returnTotal) + parseFloat(x.returnValue)

            x.collectedDate = x.collectedDate.split("T")[0];
            x.grossTotalAmount = x.grossTotalAmount.toFixed(2);
        });

        setTotal({
            ...total,
            totalBagCount: bagCount,
            totalGross: grossTotal.toFixed(2),
            totalNet: netTotal.toFixed(2),
            totalDeduction: deductionTotal.toFixed(2),
            totalReturn: returnTotal.toFixed(2)
        });

        var res = {
            totalBagCount: bagCount,
            totalGross: grossTotal,
            totalNet: netTotal,
            totalDeduction: deductionTotal,
            totalReturn: returnTotal
        }

        return res;
    }

    function createDataTable() {
        $("#customerLeafWiseCollectionReport").DataTable({
            "order": [[0, "desc"]]
        });
    }

    function destroyDataTable() {
        $("#customerLeafWiseCollectionReport").DataTable().destroy();
    }

    function createFile() {
        var settings = {
            sheetName: 'Customer LeafCollection History',
            fileName: 'Customer Leaf Collection History Report',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true);
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setSearchDetails({
            ...searchDetails,
            routeID: "0",
            collectionTypeID: "0",
            regNO: ""
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            collectionType: collectionTypes[searchForm.collectionTypeID],
            regNo: searchForm.regNo,
            fromDate: searchForm.fromDate,
            toDate: searchForm.toDate
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Customer Leaf Collection History Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={searchDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={searchDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={searchDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="">Collection Type</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionTypeID"
                                            id="collectionTypeID"
                                            name="collectionTypeID"
                                            value={searchDetails.collectionTypeID}
                                            onChange={(e) => handleCollectionTypeChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Ceollection Type--</MenuItem>
                                            {generateDropDownMenu(collectionTypes)}
                                        </Select>
                                        {errors["collectionTypeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionTypeID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="regNo">Customer Reg. Number</InputLabel>
                                        <TextField
                                            fullWidth
                                            labelId="regNo"
                                            id="regNo"
                                            name="regNo"
                                            value={searchDetails.regNo}
                                            onChange={(e) => handleRegNoChange(e.target)}
                                        >
                                        </TextField>
                                        {errors["regNo"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["regNo"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="searchDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="searchDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, searchDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div className="pt-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="customerLeafWiseCollectionReport" className="display dataTable no-footer" style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Collected Date</th>
                                                            <th>Route Name</th>
                                                            <th>Customer Reg. Number</th>
                                                            <th>Customer Name</th>
                                                            <th>Narration</th>
                                                            <th>Collection Type</th>
                                                            <th>Bag Count</th>
                                                            <th>Gross Amount Total (Kg)</th>
                                                            <th>Total Deduction (Kg)</th>
                                                            <th>Return Total (Kg)</th>
                                                            <th>Net Amount Total (Kg)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentForCustomerLeafWiseCollection
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan={6}>Total</th>
                                                            <th style={{ textAlign: "right" }}>{total.totalBagCount}</th>
                                                            <th style={{ textAlign: "right" }}>{total.totalGross}</th>
                                                            <th style={{ textAlign: "right" }}>{total.totalDeduction}</th>
                                                            <th style={{ textAlign: "right" }}>{total.totalReturn}</th>
                                                            <th style={{ textAlign: "right" }}>{total.totalNet}</th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-3">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Route Wise Crop Details Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} total={total}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
